import { Injectable } from '@angular/core';
import { ToastrService } from '../toastr/toastr.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private toastService: ToastrService) {}

  handleError(error: any, errorMessage: string): void {

    let jsonError = typeof error.toJSON == 'function';
    
    jsonError ? this.toastService.showErrorToastr(error.message) : this.toastService.showErrorToastr(errorMessage)
  }
}
